const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.453,
    height: 20.273,
    viewBox: "0 0 19.453 20.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 807"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 806"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5085",
    d: "M28.874 10.4a.594.594 0 0 1 0-.525l.756-1.547a1.76 1.76 0 0 0-.759-2.337l-1.521-.81a.594.594 0 0 1-.309-.425l-.3-1.7a1.76 1.76 0 0 0-1.988-1.444l-1.7.241a.594.594 0 0 1-.5-.162L21.314.5a1.76 1.76 0 0 0-2.457 0l-1.238 1.2a.594.594 0 0 1-.5.162l-1.7-.241a1.76 1.76 0 0 0-1.988 1.444l-.3 1.7a.594.594 0 0 1-.309.425l-1.522.798a1.76 1.76 0 0 0-.759 2.337l.759 1.547a.594.594 0 0 1 0 .525l-.756 1.547a1.76 1.76 0 0 0 .759 2.337l1.521.807a.594.594 0 0 1 .309.425l.3 1.7a1.759 1.759 0 0 0 1.735 1.462 1.808 1.808 0 0 0 .253-.018l1.7-.241a.594.594 0 0 1 .5.162l1.237 1.2a1.76 1.76 0 0 0 2.457 0l1.237-1.2a.6.6 0 0 1 .5-.162l1.7.241a1.76 1.76 0 0 0 1.988-1.444l.3-1.7a.594.594 0 0 1 .309-.425l1.521-.807a1.76 1.76 0 0 0 .759-2.337zM17.747 4.873A2.144 2.144 0 1 1 15.6 7.017a2.146 2.146 0 0 1 2.147-2.144zm-1.107 9.534a.585.585 0 0 1-.827-.827l7.717-7.717a.585.585 0 0 1 .827.827zm5.784.99a2.144 2.144 0 1 1 2.144-2.144 2.146 2.146 0 0 1-2.144 2.147z",
    transform: "translate(-10.359 .002)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 809"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 808"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5086",
    d: "M291.426 310.141a.974.974 0 1 0 .974.974.976.976 0 0 0-.974-.974z",
    transform: "translate(-279.361 -297.86)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 811"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 810"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5087",
    d: "M173.307 152.646a.974.974 0 1 0 .974.974.975.975 0 0 0-.974-.974z",
    transform: "translate(-165.919 -146.602)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/offers.b835f9877f66933e61d9c6e0c6ec80ba.svg";
export { ForwardRef as ReactComponent };